module.exports = __webpack_public_path__ + "img/logos_customer_12.fb9a7714.svg";